import { render, staticRenderFns } from "./exhibition-activity-live.vue?vue&type=template&id=0f311416&scoped=true&"
import script from "./exhibition-activity-live.vue?vue&type=script&lang=js&"
export * from "./exhibition-activity-live.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f311416",
  null
  
)

export default component.exports